import { AxiosInstance } from 'axios';

import * as common from '../../../../../../typings/api/skymap/rest/v1/.common';
import * as types from '../../../../../../typings/api/skymap/rest/v1/company';
import { toUrlSearchParams } from './utils';

export class CompanyServiceV1 implements types.Handlers {
  constructor(private axios: AxiosInstance) {}

  async getCompanies(params: types.GetCompaniesParameters): Promise<types.GetCompaniesResponse> {
    const { data } = await this.axios.get<types.GetCompaniesResponse>('/v1/companies', {
      params: new URLSearchParams([
        ...(params.query.name ? [['name', params.query.name]] : []),
        ...(params.query.limit !== undefined ? [['limit', String(params.query.limit)]] : []),
        ...(params.query.offset !== undefined ? [['offset', String(params.query.offset)]] : []),
      ]),
    });
    return data;
  }

  async getCompany(params: types.GetCompanyParameters): Promise<types.GetCompanyResponse> {
    const { companyId } = params.path;
    const { data } = await this.axios.get<types.GetCompanyResponse>(`/v1/companies/${companyId}`, {
      params: new URLSearchParams([...toUrlSearchParams('include', params.query.include)]),
    });
    return data;
  }

  async attachDongleToCompany(
    params: types.AttachDongleToCompanyParameters,
  ): Promise<types.AttachDongleToCompanyResponse> {
    const { data } = await this.axios.post<types.AttachDongleToCompanyResponse>(
      `/v1/companies/${params.path.companyId}/dongle`,
      {
        ...params.body,
      },
    );
    return data;
  }

  async getAttachedDongles(
    params: types.GetAttachedDonglesParameters,
  ): Promise<common.FetchSkyMapConnectDonglesResponse> {
    const companyId: string = params.path.companyId;
    const { data } = await this.axios.get<common.FetchSkyMapConnectDonglesResponse>(
      `/v1/companies/${companyId}/dongles`,
    );
    return data;
  }

  async removeDongleFromCompany(
    params: types.RemoveDongleFromCompanyParameters,
  ): Promise<types.AttachDongleToCompanyResponse> {
    const { data } = await this.axios.delete<types.AttachDongleToCompanyResponse>(
      `/v1/companies/${params.path.companyId}/dongle`,
      { data: params.body },
    );
    return data;
  }

  async getSkyMapConnectLicenseAgreement(
    params: types.GetSkyMapConnectLicenseAgreementParameters,
  ): Promise<types.GetSkyMapConnectLicenseAgreementResponse> {
    const { data } = await this.axios.get<types.GetSkyMapConnectLicenseAgreementResponse>(
      `/v1/companies/${params.path.companyId}/skymap-connect-license-agreement`,
    );
    return data;
  }

  async createSkyMapConnectLicenseAgreement(
    params: types.CreateSkyMapConnectLicenseAgreementParameters,
  ): Promise<types.GetSkyMapConnectLicenseAgreementResponse> {
    const { data } = await this.axios.post<types.GetSkyMapConnectLicenseAgreementResponse>(
      `/v1/companies/${params.path.companyId}/skymap-connect-license-agreement`,
    );
    return data;
  }

  async respondToProjectTransferRequest(
    params: types.RespondToProjectTransferRequestParameters,
  ): Promise<types.RespondToProjectTransferRequestResponse> {
    const { companyId, token } = params.path;
    const { data } = await this.axios.post<types.RespondToProjectTransferRequestResponse>(
      `/v1/companies/${companyId}/project-transfer-requests/${encodeURIComponent(token)}/respond`,
      params.body,
    );
    return data;
  }

  async getProjectTransferRequests(
    params: types.GetProjectTransferRequestsParameters,
  ): Promise<types.GetProjectTransferRequestsResponse> {
    const { data } = await this.axios.get<types.GetProjectTransferRequestsResponse>(
      '/v1/companies/project-transfer-requests',
      {
        params: new URLSearchParams([...toUrlSearchParams('include', params.query.include)]),
      },
    );
    return data;
  }
}
